import { jsx as _jsx } from "react/jsx-runtime";
import { Checkbox } from "antd";
// interface ISelectionHeader {};
const SelectionHeader = ({ column }) => {
    const { allSelected, someButNotAllSelected } = column;
    const _handleChange = (e) => {
        const { onChangeSelectAll } = column;
        onChangeSelectAll({ selected: e.target.checked });
    };
    return (_jsx(Checkbox, { indeterminate: someButNotAllSelected, checked: allSelected, onChange: _handleChange }));
};
export default SelectionHeader;
